import { useState, useEffect } from "react";
import { X, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const SIGNUP_BANNER_SCROLL_THRESHOLD = 400;
const SIGNUP_BANNER_DISMISSED_KEY = "signup-banner-dismissed";
const SIGNUP_BANNER_EVENT = "signup-banner-visibility";

export const SignupBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(SIGNUP_BANNER_DISMISSED_KEY);
    if (dismissed) return;

    const updateVisibility = () => {
      setIsVisible(window.scrollY > SIGNUP_BANNER_SCROLL_THRESHOLD);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    return () => window.removeEventListener("scroll", updateVisibility);
  }, []);

  useEffect(() => {
    document.body.dataset.signupBannerVisible = isVisible ? "true" : "false";
    window.dispatchEvent(
      new CustomEvent(SIGNUP_BANNER_EVENT, {
        detail: { isVisible },
      })
    );

    return () => {
      document.body.dataset.signupBannerVisible = "false";
      window.dispatchEvent(
        new CustomEvent(SIGNUP_BANNER_EVENT, {
          detail: { isVisible: false },
        })
      );
    };
  }, [isVisible]);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem(SIGNUP_BANNER_DISMISSED_KEY, "true");
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 animate-slide-in-bottom">
      <div className="border-t border-border bg-card shadow-lg">
        <div className="container mx-auto px-4 py-3">
          <div className="relative mx-auto max-w-4xl pr-10">
            <Button
              variant="ghost"
              size="icon"
              onClick={handleDismiss}
              className="absolute right-0 top-1/2 h-8 w-8 -translate-y-1/2 text-muted-foreground hover:text-foreground"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </Button>

            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="space-y-1 pr-2">
                <p className="text-sm font-semibold text-foreground">
                  Save your airports for instant access
                </p>
                <p className="text-xs leading-relaxed text-muted-foreground">
                  Create a free account to keep your go-to airports one tap away.
                </p>
              </div>

              <Button
                asChild
                size="sm"
                className="min-h-[44px] w-full gap-1 whitespace-nowrap sm:w-auto"
              >
                <Link to="/auth">
                  Create free account <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};